import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../../shared/components/Header';
import { Footer } from '../../shared/components/Footer';
import { Text  } from "@gs-ux-uitoolkit-react/text";
import { Button } from "@gs-ux-uitoolkit-react/button";
import { Radio } from '@gs-ux-uitoolkit-react/radio';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import {toastService} from '@gs-ux-uitoolkit-react/toast';

// create-password?token=XXX
export function AdviseeMfaAttempts() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [dayPhoneNumber, setDayPhoneNumber] = useState<string>('');
    const [eveningPhoneNumber, setEveningPhoneNumber] = useState<string>('');

    const [linkDeactivatedError, setLinkDeactivatedError] = useState<string | null>(null);
    const navigate = useNavigate(); // Initialize the navigate function
    const [mfaType, setMfaType] = useState<string | null>();

    useEffect(() => {
        const fetchData = async () => {
            if (token) {
                let url = `/api/v2/password-invitation/${token}/summary`;
                try {
                    const response = await axios.get(url);
                    setDayPhoneNumber(response.data.worktelephone);
                    setEveningPhoneNumber(response.data.hometelephone);
                } catch (error: any) {
                    if (error?.response?.data?.displayMessage) {
                        setLinkDeactivatedError(error?.response?.data?.displayMessage);
                    }
                }
            }
        };

        fetchData();
    }, [token]);

    const handleSubmit = () => {
        const url = `/api/v2/password-invitation/${token}/mfa-attempts?mfaType=${mfaType}`; // Add mfaType as a query parameter

        axios
            .post(url, { token }) // Send only token in the body if needed
            .then((response) => {
                if (typeof mfaType === 'string') {
                    localStorage.setItem('mfaType', mfaType);
                }
                navigate(`/create-password/${token}/mfa-verification`); // Redirect to the mfa-verification page
            })
            .catch((error) => {
                console.error("Error:", error);
                toastService.show({
                    status: 'error',
                    message: error?.response?.data?.displayMessage,
                    placement: 'top',
                    dismissible: true,
                    className: 'top-20',
                    autoDismiss: 3_500
                });
            });
    };

    return (
        <>
            <Header />
            {linkDeactivatedError === "Your account is locked due to too many failed attempts. Please contact support." ? (
                <div className="bg-red-10 p-4 rounded w-full max-w-screen-md mx-auto mt-4">
                    <Text typography="textBody02Medium" color="red060" className="mb-2">
                        Error
                    </Text>
                    <Text typography="textBody02Regular" color="red060">
                        {linkDeactivatedError}
                    </Text>
                </div>
            ) : (
                <>
                    <div className="justify-between flex-1 flex flex-col min-[700px]:flex-row items-center px-16 py-16 xl:gap-72 lg:gap-24 md:gap-12 sm:gap-6">
                        <div className="self-stretch px-6 inline-flex justify-center items-center gap-2.5">
                            <Text typography="textSubtitle03Medium">For security purposes, please confirm your phone number to receive a one-time security code.</Text>
                        </div>
                    </div>
                    <div className="flex flex-col px-16 ">
                        <div className="flex flex-col gap-2 px-6 pb-2">
                            <Text typography="textBody02Regular">Choose a verification method</Text>
                            <Text typography="textBody04Regular">Check your 'Spam' or 'Unknown Senders' folder if the SMS code does not arrive shortly.</Text>
                        </div>
                        <div className="flex flex-col gap-3 px-6 pt-4">
                            <Text typography="textBody01Regular" color="colorTextNeutralBold">Text</Text>
                            <div className="flex flex-col gap-2 pl-2">
                                {dayPhoneNumber &&
                                    <Radio name="mfaradio" size="lg" onClick={() => {setMfaType("daySms")}}>
                                        {dayPhoneNumber}
                                    </Radio>
                                }
                                {eveningPhoneNumber &&
                                    <Radio name="mfaradio" size="lg" onClick={() => {setMfaType("eveningSms")}}>
                                        {eveningPhoneNumber}
                                    </Radio>
                                }
                            </div>
                        </div>

                        <div className="flex flex-col gap-3 px-6 pt-4">
                            <Text typography="textBody01Regular" color="colorTextNeutralBold">Call</Text>
                            <div className="flex flex-col gap-2 pl-2">
                                {dayPhoneNumber &&
                                    <Radio name="mfaradio" size="lg" onClick={() => {setMfaType("dayCall")}}>
                                        {dayPhoneNumber}
                                    </Radio>
                                }
                                {eveningPhoneNumber &&
                                    <Radio name="mfaradio" size="lg" onClick={() => {setMfaType("eveningCall")}}>
                                        {eveningPhoneNumber}
                                    </Radio>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-span-12 mt-4 px-20 py-4 bg-gray-10">
                        <Button
                            className="bg-blue-60 rounded"
                            size="lg"
                            type="submit"
                            onClick={handleSubmit} 
                            appearance="neutral"
                        >
                            Continue
                        </Button>
                    </div>
                </>
            )}
            <Footer/>
        </>
    );
};
